export const appId = '99f4d21f-2ae4-4589-b34c-1330a3f6b4da';

export const secret = 'xr3pkwk7DH9lY8Oj5IzDShjx7MH9YhPDiqwEmPcw9NA=';
